export const constructCustomerScope = (customerId: string): string => {
  return 'customer/' + customerId;
};

export const getCustomerId = (scope: string): string => {
  return scope.replace('customer/', '');
};
